import { mapValues } from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { Button, FormControl, InputGroup } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import '../DatePickerAdapter.css';
import styles from './DateRangeFilter.module.css';

DateRangeFilter.propTypes = {
  startDate: PropTypes.string,
  endDate: PropTypes.string,
};

DateRangeFilter.defaultProps = {
  startDate: undefined,
  endDate: undefined,
};

class DatePickerInput extends React.Component {
  static propTypes = {
    onClear: PropTypes.func.isRequired,
  };

  focus = () => this.input.focus();

  render() {
    const { onClear, ...inputProps } = this.props;

    return (
      <InputGroup>
        <FormControl {...inputProps} inputRef={(ref) => (this.input = ref)} />
        <InputGroup.Button>
          <Button onClick={onClear} bsStyle="info">
            <span aria-hidden="true">&times;</span>
            <span className="sr-only">Clear</span>
          </Button>
        </InputGroup.Button>
      </InputGroup>
    );
  }
}

const DATE_PROP_FORMAT = 'YYYY-MM-DD';

function DateRangeFilter({ startDate, endDate, navigateAction }) {
  const startKey = 'startDate';
  const endKey = 'endDate';
  const startMoment = startDate && moment(startDate, DATE_PROP_FORMAT);
  const endMoment = endDate && moment(endDate, DATE_PROP_FORMAT);

  const handleChange = (dateQuery) => {
    const formattedQuery = mapValues(dateQuery, (value) =>
      moment.isMoment(value) ? value.format(DATE_PROP_FORMAT) : value
    );

    // Preserve both dates - only update the one being changed
    navigateAction({
      startDate:
        formattedQuery.startDate !== undefined
          ? formattedQuery.startDate
          : startDate,
      endDate:
        formattedQuery.endDate !== undefined ? formattedQuery.endDate : endDate,
    });
  };

  return (
    <div className={`flex report-filter ${styles.reportFilter}`}>
      <div className="flex-col">
        <div className="text-muted filter-label">Change Impact Date Range</div>
        <div className="flex">
          <div className="m-r-4">
            <DatePicker
              selected={startMoment}
              onChange={(date) => handleChange({ [startKey]: date })}
              selectsStart
              startDate={startMoment}
              endDate={endMoment}
              dateFormat="M/D/YY"
              placeholderText="Start Date"
              customInput={
                <DatePickerInput
                  onClear={() => handleChange({ [startKey]: null })}
                />
              }
            />
          </div>
          <div className="m-l-4">
            <DatePicker
              selected={endMoment}
              onChange={(date) => handleChange({ [endKey]: date })}
              selectsEnd
              startDate={startMoment}
              endDate={endMoment}
              dateFormat="M/D/YY"
              placeholderText="End Date"
              customInput={
                <DatePickerInput
                  onClear={() => handleChange({ [endKey]: null })}
                />
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default DateRangeFilter;
